var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-redeclare, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp, space-infix-ops */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var ButtonGroup = require("react-components/button-group.jsx");
var Editor = require("../editor.jsx");

var _require = require("../icon-paths.js"),
    iconGear = _require.iconGear,
    iconTrash = _require.iconTrash;

var InfoTip = require("../components/info-tip.jsx");
var InlineIcon = require("../components/inline-icon.jsx");
var MultiButtonGroup = require("react-components/multi-button-group.jsx");
var NumberInput = require("../components/number-input.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");
var TextInput = require("../components/text-input.jsx");

var firstNumericalParse = require("../util.js").firstNumericalParse;

var answerFormButtons = [{ title: "Integers", value: "integer", content: "6" }, { title: "Decimals", value: "decimal", content: "0.75" }, { title: "Proper fractions", value: "proper", content: "\u2157" }, {
    title: "Improper fractions",
    value: "improper",
    content: "\u2077\u2044\u2084"
}, { title: "Mixed numbers", value: "mixed", content: "1\xBE" }, { title: "Numbers with \u03C0", value: "pi", content: "\u03C0" }];

var initAnswer = function initAnswer(status) {
    return {
        value: null,
        status: status,
        message: "",
        simplify: "required",
        answerForms: [],
        strict: false,
        maxError: null
    };
};

var NumericInputEditor = React.createClass({
    displayName: "NumericInputEditor",

    propTypes: _extends({}, Changeable.propTypes),

    getDefaultProps: function getDefaultProps() {
        return {
            answers: [initAnswer("correct")],
            size: "normal",
            coefficient: false,
            labelText: "",
            multipleNumberInput: false
        };
    },

    getInitialState: function getInitialState() {
        return {
            lastStatus: "wrong",
            showOptions: _.map(this.props.answers, function () {
                return false;
            })
        };
    },

    render: function render() {
        var _this = this;

        var answers = this.props.answers;

        var unsimplifiedAnswers = function unsimplifiedAnswers(i) {
            return React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    null,
                    "Unsimplified answers are"
                ),
                React.createElement(ButtonGroup, {
                    value: answers[i]["simplify"],
                    allowEmpty: false,
                    buttons: [{ value: "required", content: "ungraded" }, { value: "optional", content: "accepted" }, { value: "enforced", content: "wrong" }],
                    onChange: _this.updateAnswer(i, "simplify")
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Normally select \"ungraded\". This will give the user a message saying the answer is correct but not simplified. The user will then have to simplify it and re-enter, but will not be penalized. (5th grade and after)"
                    ),
                    React.createElement(
                        "p",
                        null,
                        "Select \"accepted\" only if the user is not expected to know how to simplify fractions yet. (Anything prior to 5th grade)"
                    ),
                    React.createElement(
                        "p",
                        null,
                        "Select \"wrong\" ",
                        React.createElement(
                            "em",
                            null,
                            "only"
                        ),
                        " if we are specifically assessing the ability to simplify."
                    )
                )
            );
        };

        var suggestedAnswerTypes = function suggestedAnswerTypes(i) {
            return React.createElement(
                "div",
                null,
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(
                        "label",
                        null,
                        "Choose the suggested answer formats"
                    ),
                    React.createElement(MultiButtonGroup, {
                        buttons: answerFormButtons,
                        values: answers[i]["answerForms"],
                        onChange: _this.updateAnswer(i, "answerForms")
                    }),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "Formats will be autoselected for you based on the given answer; to show no suggested formats and accept all types, simply have a decimal/integer be the answer. Values with \u03C0 will have format \"pi\", and values that are fractions will have some subset (mixed will be \"mixed\" and \"proper\"; improper/proper will both be \"improper\" and \"proper\"). If you would like to specify that it is only a proper fraction (or only a mixed/improper fraction), deselect the other format. Except for specific cases, you should not need to change the autoselected formats."
                        ),
                        React.createElement(
                            "p",
                            null,
                            "To restrict the answer to ",
                            React.createElement(
                                "em",
                                null,
                                "only"
                            ),
                            " an improper fraction (i.e. 7/4), select the improper fraction and toggle \"strict\" to true. This ",
                            React.createElement(
                                "b",
                                null,
                                "will not"
                            ),
                            " ",
                            " accept 1.75 as an answer.",
                            " "
                        ),
                        React.createElement(
                            "p",
                            null,
                            "Unless you are testing that specific skill, please do not restrict the answer format."
                        )
                    )
                ),
                React.createElement(
                    "div",
                    { className: "perseus-widget-row" },
                    React.createElement(PropCheckBox, {
                        label: "Strictly match only these formats",
                        strict: answers[i]["strict"],
                        onChange: _this.updateAnswer.bind(_this, i)
                    })
                )
            );
        };

        var maxError = function maxError(i) {
            return React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    null,
                    "Max error",
                    " ",
                    React.createElement(NumberInput, {
                        className: "max-error",
                        value: answers[i]["maxError"],
                        onChange: _this.updateAnswer(i, "maxError"),
                        placeholder: "0"
                    })
                )
            );
        };

        var inputSize = React.createElement(
            "div",
            { className: "perseus-widget-row" },
            React.createElement(
                "label",
                null,
                "Width:  "
            ),
            React.createElement(ButtonGroup, {
                value: this.props.size,
                allowEmpty: false,
                buttons: [{ value: "normal", content: "Normal (80px)" }, { value: "small", content: "Small (40px)" }],
                onChange: this.change("size")
            }),
            React.createElement(
                InfoTip,
                null,
                React.createElement(
                    "p",
                    null,
                    "Use size \"Normal\" for all text boxes, unless there are multiple text boxes in one line and the answer area is too narrow to fit them."
                )
            )
        );

        var labelText = React.createElement(
            "div",
            { className: "perseus-widget-row" },
            React.createElement(
                "label",
                null,
                "Label text:",
                " ",
                React.createElement(TextInput, {
                    value: this.props.labelText,
                    onChange: this.change("labelText")
                })
            ),
            React.createElement(
                InfoTip,
                null,
                React.createElement(
                    "p",
                    null,
                    "Text to describe this input. This will be shown to users using screenreaders."
                )
            )
        );

        var coefficientCheck = React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(PropCheckBox, {
                    label: "Coefficient",
                    coefficient: this.props.coefficient,
                    onChange: this.props.onChange
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "A coefficient style number allows the student to use - for -1 and an empty string to mean 1."
                    )
                )
            )
        );

        var addAnswerButton = React.createElement(
            "div",
            null,
            React.createElement(
                "a",
                {
                    href: "javascript:void(0)",
                    className: "simple-button orange",
                    onClick: function onClick() {
                        return _this.addAnswer();
                    },
                    onKeyDown: function onKeyDown(e) {
                        return _this.onSpace(e, _this.addAnswer);
                    }
                },
                React.createElement(
                    "span",
                    null,
                    "Add new answer"
                )
            )
        );

        var instructions = {
            wrong: "(address the mistake/misconception)",
            ungraded: "(explain in detail to avoid confusion)",
            correct: "(reinforce the user's understanding)"
        };

        var generateInputAnswerEditors = function generateInputAnswerEditors() {
            return answers.map(function (answer, i) {
                var editor = React.createElement(Editor, {
                    apiOptions: _this.props.apiOptions,
                    content: answer.message || "",
                    placeholder: "Why is this answer " + answer.status + "?\t" + instructions[answer.status],
                    widgetEnabled: false,
                    onChange: function onChange(newProps) {
                        if ("content" in newProps) {
                            _this.updateAnswer(i, {
                                message: newProps.content
                            });
                        }
                    }
                });
                return React.createElement(
                    "div",
                    { className: "perseus-widget-row", key: i },
                    React.createElement(
                        "div",
                        {
                            className: "input-answer-editor-value-container" + (answer.maxError ? " with-max-error" : "")
                        },
                        React.createElement(NumberInput, {
                            value: answer.value,
                            className: "numeric-input-value",
                            placeholder: "answer",
                            format: _.last(answer.answerForms),
                            onFormatChange: function onFormatChange(newValue, format) {
                                // NOTE(charlie): The mobile web expression
                                // editor relies on this automatic answer
                                // form resolution for determining when to
                                // show the Pi symbol. If we get rid of it,
                                // we should also disable Pi for
                                // NumericInput and require problems that
                                // use Pi to build on Expression.
                                // Alternatively, we could store answers
                                // as plaintext and parse them to determine
                                // whether or not to reveal Pi on the
                                // keypad (right now, answers are stored as
                                // resolved values, like '0.125' rather
                                // than '1/8').
                                var forms;
                                if (format === "pi") {
                                    forms = ["pi"];
                                } else if (format === "mixed") {
                                    forms = ["proper", "mixed"];
                                } else if (format === "proper" || format === "improper") {
                                    forms = ["proper", "improper"];
                                }
                                _this.updateAnswer(i, {
                                    value: firstNumericalParse(newValue),
                                    answerForms: forms
                                });
                            },
                            onChange: function onChange(newValue) {
                                _this.updateAnswer(i, {
                                    value: firstNumericalParse(newValue)
                                });
                            }
                        }),
                        answer.strict && React.createElement(
                            "div",
                            {
                                className: "is-strict-indicator",
                                title: "strictly equivalent to"
                            },
                            "\u2261"
                        ),
                        answer.simplify !== "required" && answer.status === "correct" && React.createElement(
                            "div",
                            {
                                className: "simplify-indicator " + answer.simplify,
                                title: "accepts unsimplified answers"
                            },
                            "\u2030"
                        ),
                        answer.maxError ? React.createElement(
                            "div",
                            { className: "max-error-container" },
                            React.createElement(
                                "div",
                                { className: "max-error-plusmn" },
                                "\xB1"
                            ),
                            React.createElement(NumberInput, {
                                placeholder: 0,
                                value: answers[i]["maxError"],
                                format: _.last(answer.answerForms),
                                onChange: _this.updateAnswer(i, "maxError")
                            })
                        ) : null,
                        React.createElement("div", { className: "value-divider" }),
                        React.createElement(
                            "a",
                            {
                                href: "javascript:void(0)",
                                className: "answer-status " + answer.status,
                                onClick: function onClick() {
                                    return _this.onStatusChange(i);
                                },
                                onKeyDown: function onKeyDown(e) {
                                    return _this.onSpace(e, _this.onStatusChange, i);
                                }
                            },
                            answer.status
                        ),
                        React.createElement(
                            "a",
                            {
                                href: "javascript:void(0)",
                                className: "answer-trash",
                                onClick: function onClick() {
                                    return _this.onTrashAnswer(i);
                                },
                                onKeyDown: function onKeyDown(e) {
                                    return _this.onSpace(e, _this.onTrashAnswer, i);
                                }
                            },
                            React.createElement(InlineIcon, iconTrash)
                        ),
                        React.createElement(
                            "a",
                            {
                                href: "javascript:void(0)",
                                className: "options-toggle",
                                onClick: function onClick() {
                                    return _this.onToggleOptions(i);
                                },
                                onKeyDown: function onKeyDown(e) {
                                    return _this.onSpace(e, _this.onToggleOptions, i);
                                }
                            },
                            React.createElement(InlineIcon, iconGear)
                        )
                    ),
                    React.createElement(
                        "div",
                        { className: "input-answer-editor-message" },
                        editor
                    ),
                    _this.state.showOptions[i] && React.createElement(
                        "div",
                        { className: "options-container" },
                        maxError(i),
                        answer.status === "correct" && unsimplifiedAnswers(i),
                        suggestedAnswerTypes(i)
                    )
                );
            });
        };

        return React.createElement(
            "div",
            { className: "perseus-input-number-editor" },
            React.createElement(
                "div",
                { ref: function ref(e) {
                        return _this.multInputOption = e;
                    } },
                React.createElement(
                    "select",
                    { onChange: this.onMultipleInputChange },
                    React.createElement(
                        "option",
                        { value: "simple-numeric-input" },
                        "Ask for one correct solution"
                    ),
                    React.createElement(
                        "option",
                        { value: "multiple-numeric-input" },
                        "Ask for all correct solutions"
                    )
                )
            ),
            React.createElement(
                "div",
                { className: "ui-title" },
                "User input"
            ),
            React.createElement(
                "div",
                { className: "msg-title" },
                "Message shown to user on attempt"
            ),
            generateInputAnswerEditors(),
            addAnswerButton,
            inputSize,
            coefficientCheck,
            labelText
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    onToggleOptions: function onToggleOptions(choiceIndex) {
        var showOptions = this.state.showOptions.slice();
        showOptions[choiceIndex] = !showOptions[choiceIndex];
        this.setState({ showOptions: showOptions });
    },

    onTrashAnswer: function onTrashAnswer(choiceIndex) {
        if (choiceIndex >= 0 && choiceIndex < this.props.answers.length) {
            var answers = this.props.answers.slice(0);
            answers.splice(choiceIndex, 1);
            this.props.onChange({ answers: answers });
        }
    },

    onSpace: function onSpace(e, callback) {
        if (e.key === " ") {
            e.preventDefault(); // prevent page shifting
            var args = _.toArray(arguments).slice(2);
            callback.apply(this, args);
        }
    },

    onStatusChange: function onStatusChange(choiceIndex) {
        var statuses = ["wrong", "ungraded", "correct"];
        var answers = this.props.answers;
        var i = _.indexOf(statuses, answers[choiceIndex].status);
        var newStatus = statuses[(i + 1) % statuses.length];

        this.updateAnswer(choiceIndex, {
            status: newStatus,
            simplify: newStatus === "correct" ? "required" : "accepted"
        });
    },

    onMultipleInputChange: function onMultipleInputChange(event) {
        var newOption = event.target.value;
        if (newOption === "multiple-numeric-input") {
            this.props.onChange({ multipleNumberInput: true });
        } else {
            this.props.onChange({ multipleNumberInput: false });
        }
    },

    updateAnswer: function updateAnswer(choiceIndex, update) {
        var _this2 = this;

        if (!_.isObject(update)) {
            return _.partial(function (choiceIndex, key, value) {
                var update = {};
                update[key] = value;
                _this2.updateAnswer(choiceIndex, update);
            }, choiceIndex, update);
        }

        var answers = _.clone(this.props.answers);

        // Don't bother to make a new answer box unless we are editing the last
        // one.
        // TODO(oliver): This might not be necessary anymore.
        if (choiceIndex === answers.length) {
            var lastAnswer = initAnswer(this.state.lastStatus);
            var answers = answers.concat(lastAnswer);
        }

        answers[choiceIndex] = _.extend({}, answers[choiceIndex], update);
        this.props.onChange({ answers: answers });
    },

    addAnswer: function addAnswer() {
        var lastAnswer = initAnswer(this.state.lastStatus);
        var answers = this.props.answers.concat(lastAnswer);
        this.props.onChange({ answers: answers });
    },

    getSaveWarnings: function getSaveWarnings() {
        // Filter out all the empty answers
        var warnings = [];
        // TODO(emily): This doesn't actually work, because the value is either
        // null or undefined when undefined, probably.
        if (_.contains(_.pluck(this.props.answers, "value"), "")) {
            warnings.push("One or more answers is empty");
        }
        this.props.answers.forEach(function (answer, i) {
            var formatError = answer.strict && (!answer.answerForms || answer.answerForms.length === 0);
            if (formatError) {
                warnings.push("Answer " + (i + 1) + " is set to string format " + "matching, but no format was selected");
            }
        });
        return warnings;
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = NumericInputEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/numeric-input-editor.jsx
 ** module id = 72
 ** module chunks = 0 2
 **/